(() => {
  if (window.cfCollectionShopping || !document.documentElement.classList.contains('cf-collection-shopping')) return;
  window.cfCollectionShopping = true;
  const quietPromotions = () => {
    document.querySelectorAll('[data-kl-scroll-locking-modal]').forEach(modal => {
      const close = modal.querySelector('button[aria-label="Close dialog"]');
      if (close && modal.dataset.cfCollectionDismissed !== 'true') {
        modal.dataset.cfCollectionDismissed = 'true';
        close.click();
      }
    });
    document.querySelectorAll('[class*="kl-private-reset-css"] [role="button"], [class*="kl-private-reset-css"] button').forEach(button => {
      const text = (button.getAttribute('aria-label') || button.textContent || '').trim();
      if (/^(get|unlock)\s+10%\s+off!?$/i.test(text)) {
        const teaser = button.closest('[data-testid*="teaser" i]') || button;
        if (teaser.style.display !== 'none') teaser.style.setProperty('display', 'none', 'important');
      }
    });
    // The dismissed app can leave its own scroll-lock class behind while fading out.
    // Other overlays keep their independent locks (for example the variant dialog).
    if (document.body.classList.contains('klaviyo-prevent-body-scrolling')) {
      document.body.classList.remove('klaviyo-prevent-body-scrolling');
    }
  };
  const boot = () => {
    quietPromotions();
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; quietPromotions(); });
    }).observe(document.body, { childList: true, subtree: true });
    new MutationObserver(quietPromotions).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
